import './App.css';
import Dictionary from './Dictionary';

function App() {
  return (
      <div>
        <img src="/dvs.dev.png" width="300" alt=""/>
        <Dictionary defaultKeyword="bee"/>
        </div>
  );
}

export default App;
